import {
  ACTIVATE_TRAINER_SUCCESS,
  ADD_BULK_TRAINER_SUCCESS,
  ADD_TRAINER_SUCCESS,
  DEACTIVATE_TRAINER_SUCCESS,
  DOWNLOAD_TRAINER_BULK_TEMPLATE_SUCCESS,
  EMPTY_ALL_TRAINERS,
  EMPTY_TOTAL_TRAINERS,
  EMPTY_TRAINER_BY_ID,
  EMPTY_TRAINER_SELECT,
  EXPORT_TRAINERS_SUCCESS,
  FETCH_ALL_TOTAL_TRAINERS_DETAILS_SUCCESS,
  FETCH_ALL_TRAINERS_SUCCESS,
  FETCH_TRAINER_BY_ID_SUCCESS,
  FETCH_TRAINER_SELECT_SUCCESS,
  PRINT_TRAINERS_SUCCESS,
  RESTORE_TRAINER_INITIAL,
  UPDATE_TRAINER_SUCCESS,

  VIRTUALLY_APPROVE_TRAINER,
  VIRTUALLY_APPROVE_TRAINER_SUCCESS,
  VIRTUALLY_APPROVE_TRAINER_FAILURE,
  RESET_VIRTUAL_APPROVAL_STATES,
  SAVE_CURRENT_TRAINER_ID,
  RESET_CURRENT_TRAINER_ID,

  FETCH_TRAINING_CENTER_FILE_BY_ID,
  FETCH_TRAINING_CENTER_FILE_BY_ID_SUCCESS,
  FETCH_TRAINING_CENTER_FILE_BY_ID_FAILURE,
  FETCH_TRAINING_CENTER_FILE_BY_ID_RESET,

  FETCH_TRAINING_CENTER_REPORT,
  FETCH_TRAINING_CENTER_REPORT_SUCCESS,
  FETCH_TRAINING_CENTER_REPORT_FAILURE,

  EXPORT_TRAINING_CENTER_REPORT,
  EXPORT_TRAINING_CENTER_REPORT_FAILURE,
  EXPORT_TRAINING_CENTER_REPORT_SUCCESS,
  RESET_EXPORT_TRAINING_CENTER_REPORT,

  PRINT_TRAINING_CENTER_REPORT,
  PRINT_TRAINING_CENTER_REPORT_SUCCESS,
  PRINT_TRAINING_CENTER_REPORT_FAILURE,
  RESET_PRINT_TRAINING_CENTER_REPORT,

  FETCH_TRAINER_BY_EMAIL,
  FETCH_TRAINER_BY_EMAIL_SUCCESS,
  FETCH_TRAINER_BY_EMAIL_FAILURE,
  EMPTY_TRAINER_BY_EMAIL,

  UPDATE_TRAINING_CENTER,
  UPDATE_TRAINING_CENTER_SUCCESS,

  EXPORT_VIRTUALLY_APPROVED_TRAINERS,
  EXPORT_VIRTUALLY_APPROVED_TRAINERS_SUCCESS,
  EXPORT_VIRTUALLY_APPROVED_TRAINERS_FAILURE,
  EXPORT_VIRTUALLY_APPROVED_TRAINERS_RESET,
} from "../ActionTypes";

const INIT_STATE = {
  trainerCreated: false,
  trainersFetched: [],
  totalTrainerCount: {},
  trainerActivated: false,
  trainerDeactivated: false,
  trainer: {},
  totalTrainersDetails: {},
  trainerUpdated: false,
  isLoading: true,
  trainersCSV: false,
  trainersPDF: false,
  trainerSelectFetched: [],
  isFetched: false,
  isLoaded: true,
  bulkTrainersCSV: false,
  bulkUploadData: false,

  // virtual approval
  processingVirtualApproval: false,
  virtualApprovalSuccess: false,
  currentTrainerId: "",
  exportingVirtuallyApprovedTrainers: false,
  exportVirtuallyApprovedTrainersSuccess: false,

  fetchingTrainingCenterFile: false,
  fetchTrainingCenterFileSuccess: false,
  trainingCenterFile: '',

  // trainers report page
  fetchingTrainersReportData: true,
  reportFetchSuccess: false,
  trainersReportData: [],

  exportingTrainersReport: false, // used for loading overlay / spinner
  exportTrainersReportSuccess: false, // tracks API response success state

  printingTrainersReport: false,
  printTrainersReportSuccess: false,
  trainersReportDataNoPagination: null,

  trainingCenterDetails: {},
  centerLoading: false,

  trainingCenterUpdated: false,
  loadingUpdated: false,
};

function reducers(state = INIT_STATE, action) {
  switch (action.type) {
    case ADD_TRAINER_SUCCESS: {
      return {
        ...state,
        trainerCreated: true,
      };
    }
    case FETCH_ALL_TRAINERS_SUCCESS: {
      return {
        ...state,
        trainersFetched: action.payload.data,
        totalTrainerCount: action.payload.meta.totalCount,
      };
    }
    case EMPTY_ALL_TRAINERS: {
      return {
        ...state,
        trainersFetched: [],
      };
    }
    case RESTORE_TRAINER_INITIAL: {
      return {
        ...state,
        trainerCreated: false,
        trainerActivated: false,
        trainerDeactivated: false,
        trainerUpdated: false,
        isLoading: true,
      };
    }
    case ACTIVATE_TRAINER_SUCCESS: {
      return {
        ...state,
        trainerActivated: true,
      };
    }
    case DEACTIVATE_TRAINER_SUCCESS: {
      return {
        ...state,
        trainerDeactivated: true,
      };
    }
    case FETCH_TRAINER_BY_ID_SUCCESS: {
      return {
        ...state,
        trainer: action.payload,
      };
    }
    case EMPTY_TRAINER_BY_ID: {
      return {
        ...state,
        trainer: {},
      };
    }
    case FETCH_ALL_TOTAL_TRAINERS_DETAILS_SUCCESS: {
      return {
        ...state,
        totalTrainersDetails: action.payload,
        isLoaded: false,
      };
    }
    case EMPTY_TOTAL_TRAINERS: {
      return {
        ...state,
        totalTrainersDetails: {}
      };
    }
    case UPDATE_TRAINER_SUCCESS: {
      return {
        ...state,
        trainerUpdated: true,
      };
    }
    case EXPORT_TRAINERS_SUCCESS: {
      return {
        ...state,
        trainersCSV: action.payload,
      };
    }
    case PRINT_TRAINERS_SUCCESS: {
      return {
        ...state,
        trainersPDF: action.payload,
      }
    }
    case FETCH_TRAINER_SELECT_SUCCESS: {
      return {
        ...state,
        trainerSelectFetched: action.payload,
        isFetched: true,
      };
    }
    case EMPTY_TRAINER_SELECT: {
      return {
        ...state,
        trainerSelectFetched: [],
      };
    }
    case DOWNLOAD_TRAINER_BULK_TEMPLATE_SUCCESS: {
      return {
        ...state,
        bulkTrainersCSV: action.payload,
      };
    }
    case ADD_BULK_TRAINER_SUCCESS: {
      return {
        ...state,
        bulkUploadData: true,
      };
    }

    // virtual approval
    case VIRTUALLY_APPROVE_TRAINER: return {
      ...state,
      processingVirtualApproval: true,
    }

    case VIRTUALLY_APPROVE_TRAINER_SUCCESS: return {
      ...state,
      processingVirtualApproval: false,
      virtualApprovalSuccess: true
    }

    case VIRTUALLY_APPROVE_TRAINER_FAILURE: return {
      ...state,
      processingVirtualApproval: false,
      virtualApprovalSuccess: false
    }

    case RESET_VIRTUAL_APPROVAL_STATES: return {
      ...state,
      processingVirtualApproval: false,
      virtualApprovalSuccess: false,
      trainersFetched: [],
    }

    case FETCH_TRAINING_CENTER_FILE_BY_ID: return {
      ...state,
      fetchingTrainingCenterFile: true
    }

    case FETCH_TRAINING_CENTER_FILE_BY_ID_SUCCESS: {
      return {
        ...state,
        fetchingTrainingCenterFile: false,
        fetchTrainingCenterFileSuccess: true,
        trainingCenterFile: action.payload.data.file
      }
    }
    
    case FETCH_TRAINING_CENTER_FILE_BY_ID_FAILURE: return {
      ...state,
      fetchingTrainingCenterFile: false,
      fetchTrainingCenterFileSuccess: false,  
    }
    
    case FETCH_TRAINING_CENTER_FILE_BY_ID_RESET: return {
      ...state,
      fetchingTrainingCenterFile: false,
      fetchTrainingCenterFileSuccess: false,  
      trainingCenterFile: "",
    }

    case SAVE_CURRENT_TRAINER_ID: return {
      ...state,
      currentTrainerId: action.id,
    }

    case RESET_CURRENT_TRAINER_ID: return {
      ...state,
      currentTrainerId: "",
    }

    case FETCH_TRAINING_CENTER_REPORT: return {
      ...state,
      fetchingTrainersReportData: true,
      reportFetchSuccess: false,
    }

    case FETCH_TRAINING_CENTER_REPORT_SUCCESS: return {
      ...state,
      fetchingTrainersReportData: false,
      reportFetchSuccess: true,
      trainersReportData: action.payload
    }

    case FETCH_TRAINING_CENTER_REPORT_FAILURE: return {
      ...state,
      fetchingTrainersReportData: false,
      reportFetchSuccess: false,
    }

    case EXPORT_TRAINING_CENTER_REPORT: return {
      ...state,
      exportingTrainersReport: true,
      exportTrainersReportSuccess: false
    }

    case EXPORT_TRAINING_CENTER_REPORT_SUCCESS: return {
      ...state,
      exportingTrainersReport: false,
      exportTrainersReportSuccess: true
    }

    case EXPORT_TRAINING_CENTER_REPORT_FAILURE: return {
      ...state,
      exportingTrainersReport: false,
      exportTrainersReportSuccess: false
    }

    case RESET_EXPORT_TRAINING_CENTER_REPORT: return {
      ...state,
      exportingTrainersReport: false,
      exportTrainersReportSuccess: false,
    }

    case PRINT_TRAINING_CENTER_REPORT: return {
      ...state,
      printingTrainersReport: true,
    }

    case PRINT_TRAINING_CENTER_REPORT_SUCCESS: return {
      ...state,
      printingTrainersReport: false,
      printTrainersReportSuccess: true,
      trainersReportDataNoPagination: action.payload.data
    }

    case PRINT_TRAINING_CENTER_REPORT_FAILURE: return {
      ...state,
      printingTrainersReport: false,
      printTrainersReportSuccess: false,
    }

    case RESET_PRINT_TRAINING_CENTER_REPORT: return {
      ...state,
      printingTrainersReport: false,
      printTrainersReportSuccess: false,
    }

    case FETCH_TRAINER_BY_EMAIL: {
      return {
        ...state,
        trainingCenterDetails: {},
        centerLoading: true,
      };
    }
    case FETCH_TRAINER_BY_EMAIL_SUCCESS: {
      return {
        ...state,
        trainingCenterDetails: action.payload,
        centerLoading: false,
      };
    }
    case FETCH_TRAINER_BY_EMAIL_FAILURE: {
      return {
        ...state,
        trainingCenterDetails: [],
        centerLoading: false,
      };
    }
    case EMPTY_TRAINER_BY_EMAIL: {
      return {
        ...state,
        trainingCenterDetails: {},
      };
    }
    case UPDATE_TRAINING_CENTER: {
      return {
        ...state,
        trainingCenterUpdated: false,
        loadingUpdated: true,
      };
    }
    case UPDATE_TRAINING_CENTER_SUCCESS: {
      return {
        ...state,
        trainingCenterUpdated: true,
        loadingUpdated: false,
      };
    }
    case EXPORT_VIRTUALLY_APPROVED_TRAINERS: {
      return {
        ...state,
        exportingVirtuallyApprovedTrainers: true,
      }
    }
    case EXPORT_VIRTUALLY_APPROVED_TRAINERS_SUCCESS: {
      return {
        ...state,
        exportingVirtuallyApprovedTrainers: false,
        exportVirtuallyApprovedTrainersSuccess: true,
      }
    }
    case EXPORT_VIRTUALLY_APPROVED_TRAINERS_FAILURE: {
      return {
        ...state,
        exportingVirtuallyApprovedTrainers: false,
        exportVirtuallyApprovedTrainersSuccess: false,
      }
    }
    case EXPORT_VIRTUALLY_APPROVED_TRAINERS_RESET: {
      return {
        ...state,
        exportingVirtuallyApprovedTrainers: false,
        exportVirtuallyApprovedTrainersSuccess: false,
      }
    }

    default:
      return state;
  }
}

export default reducers;
